<template>
	<ChooseProject v-bind="$attrs" v-on="$listeners" :projects="projects" :headerText="headerText" />
</template>

<script>
import { mapGetters } from 'vuex';
import ProjectService from '@/utils/projects-service';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
import { projectsList } from '@/store/modules/projects/getters';
import { projectHasPermission } from '@/store/modules/projects/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import ProjectsService from '@/utils/projects-service';
import ChooseProject from './ChooseProject.vue';
export default {
	name: 'ChooseProjectDataProvider',
	components: { ChooseProject },
	props: {
		headerText: { type: String },
		filterOutIds: { type: Array },
	},
	computed: {
		...mapGetters(['user']),
		...mapGettersShorthand({ projectsList, projectHasPermission }),
		localProjectList() {
			const personalProjects = this.projectsList.find((x) => ProjectService.isMyPersonalProject(x, this.user)); // this is a find, instead of filter, because we limited the personal projects to be only one
			const workspaceProjects = this.projectsList.filter((x) => ProjectService.isWorkspaceProject(x));
			return personalProjects ? [personalProjects, ...workspaceProjects] : workspaceProjects;
		},
		projects() {
			return ProjectsService.getFilteredProjectsList(this.localProjectList, this.filterOutIds, null).map((project) => ({
				...project,
				disabled: !this.projectHasPermission(project.id, ProjectPermissions.ChangeWorkflows),
			}));
		},
	},
};
</script>

<style lang="scss" scoped></style>
